import React from 'react';
import { VerifyPhone } from 'components/common';

const PhoneConfirmationModal = ({ closeModal, ...rest }) => (
  <div className="relative bg-white outline-none w-auto h-auto p-10">
    <div className="text-center text-2xl p-8">Enter confirmation code</div>
    <VerifyPhone closeModal={closeModal} {...rest} />
  </div>
);

export default PhoneConfirmationModal;
